import { render } from "./AttributeDetails.vue?vue&type=template&id=390af1dd"
import script from "./AttributeDetails.vue?vue&type=script&lang=js"
export * from "./AttributeDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__